import { render } from "./PosterCardSkeleton.vue?vue&type=template&id=e0f81bfa"
import script from "./PosterCardSkeleton.vue?vue&type=script&lang=js"
export * from "./PosterCardSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/n0m4dz/workspace/projects/btv-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__